import { render, staticRenderFns } from "./EnglishFlagIcon.vue?vue&type=template&id=3f83c55b&"
import script from "./EnglishFlagIcon.vue?vue&type=script&lang=js&"
export * from "./EnglishFlagIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports